import { TodoList2 } from '@griply/assets';
import { useGoalById } from 'features/goals';
import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { EmptyState } from 'shared/components/ui/empty-state';
import { useOpenMenu } from 'shared/hooks/use-open-menu';

import { ActionPlanContextMenu } from '../action-plan-context-menu';
import * as Styled from './tasks-empty-state.style';

export const TasksEmptyState: React.FC = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const goal = useGoalById(id);
  const addButtonRef = useRef<HTMLButtonElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();

  const parentIds = useMemo(() => (goal ? [goal.id] : []), [goal]);

  if (!goal) {
    return null;
  }

  return (
    <Styled.Container>
      <EmptyState
        icon={TodoList2}
        title={t('goal-detail.tasks-preview.empty.title')}
        description={t('goal-detail.tasks-preview.empty.message')}
      >
        <Button
          ref={addButtonRef}
          variant={Variants.ContainedLight}
          color={Colors.Primary}
          size={Sizes.Small}
          onClick={openMenu}
        >
          {t('goal-detail.tasks-preview.empty.action')}
        </Button>
        {menuOpen && (
          <ActionPlanContextMenu
            referenceElement={addButtonRef}
            onClose={closeMenu}
            position="bottom-start"
            id={goal.id}
            parentIds={parentIds}
          />
        )}
      </EmptyState>
    </Styled.Container>
  );
};
